import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, } from 'vue';
import VariantColorViewObject = Vertica.LouisPoulsen.Application.Content.Pages.Product.VariantColorViewObject;
import ColorService from '@/services/color.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTileColorBaubles',
  props: {
    colors: { default: () => [] },
    isSearchTile: { type: Boolean, default: false }
  },
  emits: ["colorClicked", "focus-sync"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'colorClicked', value: VariantColorViewObject): void,
    (e: 'focus-sync', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { colors: VariantColorViewObject[], isSearchTile: boolean }



const showAllColors = ref(false);

const isKeyboardNavigation = ref(false);

const colorBaublesLimit = 7;

const colorsToShow = computed<VariantColorViewObject[]>(() => {
    return (showAllColors.value)
        ? props.colors
        : props.colors.slice(0, colorBaublesLimit);
});

const colorsAboveLimit = computed<number>(() => {
    return props.colors.length - colorBaublesLimit;
});

const showPlusElement = computed<boolean>(() => {
    if (showAllColors.value) {
        return false;
    }
    return props.colors.length > colorBaublesLimit;
});

const baubleStyle = computed<any>(() => {
    return (color: VariantColorViewObject) => {
        return color.colorImage
            ? { backgroundImage: `url('${color.colorImage}')`, backgroundSize: 'contain' }
            : { backgroundColor: color.hex };
    };
});




window.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
        isKeyboardNavigation.value = true;
    }
});

window.addEventListener('mousedown', () => {
    isKeyboardNavigation.value = false;
});

function handleFocusEvent() {
    if (isKeyboardNavigation.value) {
        handleFocus(true); //Only trigger if focus came from keyboard (Tab)
    }
}

function handleFocus(focusEvent: boolean): void {
    emit('focus-sync', focusEvent);
}

function onColorClicked(color: VariantColorViewObject): void {
    emit('colorClicked', color);
}

function onShowAllColorsClicked(): void {
    showAllColors.value = true;
}

function isColorLight(color: string): boolean {
    return ColorService.isColorLight(color);
}

return { __sfc: true,props, showAllColors, isKeyboardNavigation, colorBaublesLimit, colorsToShow, colorsAboveLimit, showPlusElement, baubleStyle, emit, handleFocusEvent, handleFocus, onColorClicked, onShowAllColorsClicked, isColorLight }
}

})